document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener("change", function(e) {
    if (!e.target.matches(".select-option")) return;

    const select = e.target;
    const selected = e.target.options[e.target.selectedIndex];
    const price = selected.dataset.price / 100;
    const cprice = selected.dataset.cprice / 100;
    const selectedId = select.value;
    const moneyFormat = window.format;
    const priceBox = select.closest(".product-card-wrapper");

      if (priceBox) {
        priceBox.querySelector(".reg_price").innerHTML = moneyFormat.replace('{{amount}}', price);
        if(cprice > price){
          priceBox.querySelector(".compare_price").innerHTML = moneyFormat.replace('{{amount}}', cprice);
        }else{
          if(priceBox.querySelector(".compare_price")){
            priceBox.querySelector(".compare_price").innerHTML = '';
          }
        }

        // Keep the "% off" pill in sync with the newly selected variant —
        // without this it kept showing whatever discount the page loaded
        // with, even after switching to a variant with a different (or no)
        // discount.
        var savePill = priceBox.querySelector(".card-save-pill");
        var percentOff = cprice > price ? Math.round(((cprice - price) / cprice) * 100) : 0;
        if (percentOff > 0) {
          if (!savePill) {
            var priceInner = priceBox.querySelector(".price__container-inner");
            if (priceInner) {
              savePill = document.createElement('span');
              savePill.className = 'card-save-pill';
              priceInner.appendChild(savePill);
            }
          }
          if (savePill) savePill.textContent = percentOff + '% off';
        } else if (savePill) {
          savePill.remove();
        }

        // Same idea for the per-pack price note — re-parse the pack count
        // from the newly selected variant's own title rather than leaving
        // the originally-rendered variant's numbers on screen.
        var packNote = priceBox.querySelector(".pack-price-note");
        if (packNote) {
          var titleText = (selected.textContent || '').toLowerCase().replace(/-/g, ' ');
          var packQty = 0;
          if (titleText.indexOf('pack') !== -1) {
            var words = titleText.trim().split(/\s+/);
            for (var i = 0; i < words.length; i++) {
              if (/^\d+(\.\d+)?$/.test(words[i])) {
                var n = parseFloat(words[i]);
                if (n > 0) {
                  packQty = n;
                  break;
                }
              }
            }
          }
          if (packQty > 0 && moneyFormat) {
            var perPack = price / packQty;
            var perPackDisplay = moneyFormat.replace('{{amount}}', perPack % 1 === 0 ? perPack : perPack.toFixed(2));
            packNote.innerHTML = perPackDisplay + ' / pack &middot; ' + packQty + ' pack' + (packQty !== 1 ? 's' : '');
            packNote.style.display = '';
          } else {
            packNote.style.display = 'none';
          }
        }
      }
      priceBox.querySelector('[name="id"]').value = selectedId;

  });
});